import React from 'react'
import PropTypes from 'prop-types'
import Button from '@/button'

const GetStartedPackageButton = ({ text, color, url }) => {
  return (
    <div className="tc">
      <Button
        link={url}
        style={{ backgroundColor: color }}
        target="_blank"
        isStretch
      >
        {text}
      </Button>
    </div>
  )
}

GetStartedPackageButton.propTypes = {
  text: PropTypes.string
}

export default GetStartedPackageButton



// WEBPACK FOOTER //
// ./src/components/get-started-package/get-started-package-button.js